import { render, staticRenderFns } from "./ProductBase.vue?vue&type=template&id=62820834&scoped=true&"
import script from "./ProductBase.vue?vue&type=script&lang=js&"
export * from "./ProductBase.vue?vue&type=script&lang=js&"
import style0 from "./ProductBase.vue?vue&type=style&index=0&id=62820834&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62820834",
  null
  
)

export default component.exports